import React from "react";
import { MESSAGE_LOADING, BUTTON_REFRESH_TEXT } from "../constants";

function Header({ siteTitle, isLoading, refreshFeed }) {
  return (
    <header className="app-header">
      <div>
        <h1 className="app-title">{siteTitle}</h1>
        <p className="app-tagline">
          Data sourced via the{" "}
          <a href="https://github.com/HackerNews/API" className="link">
            HN API
          </a>
          .
        </p>
      </div>
      <div>
        <button
          disabled={isLoading}
          className={`btn btn-refresh ${isLoading ? "is-loading" : ""}`}
          onClick={refreshFeed}
        >
          {isLoading && <p>{MESSAGE_LOADING}</p>}
          {!isLoading && <p>{BUTTON_REFRESH_TEXT}</p>}
        </button>
      </div>
    </header>
  );
}

export default Header;
